import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

jQuery(document).ready(function () {
  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

  function initCircleAnim() {
    const $tiles = $('.key-principles__item');
    const $dotActive = $('.key-principles__dots-active');
    const $path = $('#principlesMotionPathCircle');
    const $section = $('section.key-principles');

    if (
      $tiles.length === 0 ||
      $dotActive.length === 0 ||
      $path.length === 0 ||
      $section.length === 0
    ) {
      return;
    }

    const tolerance = 10;
    let circleAnim;
    let triggerInstance;

    if (circleAnim) circleAnim.kill();
    if (triggerInstance) triggerInstance.kill();

    gsap.set($dotActive, {
      motionPath: {
        path: '#principlesMotionPathCircle',
        align: '#principlesMotionPathCircle',
        autoRotate: true,
        alignOrigin: [0.5, 0.5],
        start: 0,
        end: 0,
      },
    });

    function hoverAnim() {
      $tiles.off('mouseover').on('mouseover', function () {
        const index = $(this).data('index');
        const $dot = $(`.key-principles__dot[data-index="${index}"]`);
        if ($dot.length === 0) return;

        const coord = $dot.get(0).getBoundingClientRect();

        gsap.to($dotActive, {
          x: coord.x,
          duration: 0.5,
          ease: 'power2.out',
        });
      });
    }

    circleAnim = gsap.to($dotActive, {
      duration: 5,
      ease: 'power1.inOut',
      paused: true,
      motionPath: {
        path: '#principlesMotionPathCircle',
        align: '#principlesMotionPathCircle',
        autoRotate: true,
        alignOrigin: [0.5, 0.5],
      },
      onUpdate() {
        const stopDot = $('.key-principles__dot[data-index="0"]').get(0);
        if (!stopDot) return;

        const target = this.targets()[0];
        if (!target) return;

        const stopX = stopDot.getBoundingClientRect().x;
        const currentX = target.getBoundingClientRect().x;

        if (currentX >= stopX - tolerance && currentX <= stopX + tolerance) {
          this.pause();
          hoverAnim();

          gsap.to($dotActive, {
            x: stopX,
            duration: 0.5,
            ease: 'power2.out',
          });
        }
      },
    });

    triggerInstance = ScrollTrigger.create({
      trigger: 'section.key-principles',
      start: 'center center+=250',
      once: true,
      onEnter: () => circleAnim.restart(true),
    });
  }

  function handleResize() {
    window.addEventListener('resize', () => {
      ScrollTrigger.refresh();
      initCircleAnim();
    });
  }

  window.addEventListener('load', () => {
    initCircleAnim();
    handleResize();
  });
});
